import React from "react";
import { Box } from "@mui/material";

export const drawerFieldsSx = {
  "& > .MuiFormControl-root": { gridTemplateRows: "auto auto auto", height: "auto" },
  "& .MuiFormHelperText-root": { marginTop: "2px", marginBottom: "2px" },
};

interface Props {
  testId: string;
  children: React.ReactNode;
}

/** Field stack of the dry-bulk side drawers: Figma pitch of 92 px, with the 24 px error slot kept. */
const DryBulkDrawerFields: React.FC<Props> = ({ testId, children }) => (
  <Box data-testid={testId} className="flex w-[400px] flex-col p-6" sx={drawerFieldsSx}>
    {children}
  </Box>
);

export default DryBulkDrawerFields;
